import React from 'react'
import { Box, IconButton, Tooltip, alpha, useMediaQuery, useTheme } from '@mui/material'
import ViewColumnIcon from '@mui/icons-material/ViewColumn' // Custom Columns Icon

const OpenColumnsMenu = ({ onOpenColumns }) => {
  const theme = useTheme()
  const isExtraLargeScreen = useMediaQuery(theme.breakpoints.up('xl'))
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))
  const isMediumScreen = useMediaQuery(theme.breakpoints.up('md'))
  const isSmallScreen = useMediaQuery(theme.breakpoints.up('sm'))

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Tooltip title='Columns'>
        <IconButton
          sx={{
            height: 35,
            width: 35,
            borderRadius: '0px',
            '&:hover': {
              backgroundColor: alpha(theme.palette.text.primary, 0.1),
            },
          }}
          onClick={onOpenColumns}
        >
          <ViewColumnIcon
            sx={{
              fontSize: '30px',
            }}
          />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

export default OpenColumnsMenu
